import { EMPTY_ARRAY } from 'commons-ui';

import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;
	return {
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.finance,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updateTDSConfigs,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Clone',
				id: 'clone',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.finance,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createTDSConfigs,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Remove from App',
				id: 'remove',
				isEnabled: () => {
					return true;
				}
			}
		],

		bulkActions: EMPTY_ARRAY,

		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.finance,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createTDSConfigs,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
